import Icon from 'snippets/icon/icon'
import ProductSpiffPersonalise from '@/components/snippets/spiff/btn-spiff-personalise'

function CartGiftMessage({ classWrapper, classButton, cart, hiddenGiftMessage }) {
  const spiffConfigCart = SLS_STATE?.spiffConfig?.cart || {}
  // eslint-disable-next-line no-unneeded-ternary
  const existingSpiffGiftProduct = cart.items.find(x => x?.properties?.isCartGift === true) || false
  const {
    spiffCartGiftEnable,
    spiffCartGiftProduct
  } = spiffConfigCart

  return !existingSpiffGiftProduct && spiffCartGiftEnable && spiffCartGiftProduct && !hiddenGiftMessage &&
    <div className={`flex ${classWrapper} items-center justify-between border border-secondary rounded bg-secondary/[.08] p-4 md:px-4 md:py-[11px] mt-4 mx-4 md:mt-6 md:mx-6`}>
      <div className="flex items-center justify-start w-full mb-3 md:mb-0">
        <Icon className="w-6 h-6 mr-3 text-secondary-hover" name="icon-note" viewBox="0 0 24 24" />
        <div className="flex-1 font-bold tracking-normal text-label text-secondary-hover">
          <p>Sending a gift today?</p>
          <p>Add a personalised greeting card</p>
        </div>
      </div>
      {spiffCartGiftProduct && <ProductSpiffPersonalise
        type="button"
        buttonClass={`${classButton} rounded border border-secondary bg-secondary py-2 px-4 text-white label normal-case hover:bg-secondary/[.08] hover:text-secondary transition-colors tracking-normal`}
        buttonText={'Add gift card'}
        spiffProductReference={spiffCartGiftProduct}
        shopifyVariantId={spiffCartGiftProduct.variants[0].id}
        isAvailable={spiffCartGiftProduct.available}
        addParentVariantToCart={false}
        customSpiffProductProperties={{ isCartGift: true }}
      />}
    </div>
}

export default CartGiftMessage
